import { NotificationManager } from "react-notifications";
export default (status, message) => {
  if (status === 200) {
    NotificationManager.success(message, "", 1000);
  } else {
    NotificationManager.error(message, "", 2000);
  }
};
